import { render, staticRenderFns } from "./AtopicDermatitisSummary.vue?vue&type=template&id=5ccd1780&scoped=true&"
import script from "./AtopicDermatitisSummary.vue?vue&type=script&lang=js&"
export * from "./AtopicDermatitisSummary.vue?vue&type=script&lang=js&"
import style0 from "./AtopicDermatitisSummary.vue?vue&type=style&index=0&id=5ccd1780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccd1780",
  null
  
)

export default component.exports